import Aibox from './src/main';

/* istanbul ignore next */
Aibox.install = function(Vue) {
  Vue.component(Aibox.name, Aibox);
};

export default Aibox;
